import React, { useContext, useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BlackAdd, BlueAdd, ClockSmall } from "../../../assets/Logos/Icons";
import AddDataModal from "../../PrintPrescription/Components/Modals/AddDataModal/AddDataModal";
import Searchbox from "../SearchBox/Searchbox";
import styles from "./index.module.scss";
import { ManageDataInPrescription } from "../../../actions/ManagePrescriptionAction";
import { TOGGLE_SELECT_EXAMONATION_PRESCRIPTION } from "../../../actions/type";
import { saveLabFindings } from "../../../reducers/symptom.api";
import { Select, Radio } from "antd";
import TextInput from "react-autocomplete-input";
import { PrescriprionContext } from "../../PrintPrescription/PrintPrescription";
import Textarea from "react-expanding-textarea";
import { getDepartmentList } from "../../../reducers/symptom.api";

function ExaminationBox({
  name,
  addTitle,
  initialData,
  selectedData,
  handleSearch,
  handleAdd,
  toggle,
  callBackFunction,
  detailedData,
  noteValue,
  mode = "multi",
}) {
  const [isOpen, setOpne] = useState(false);
  const [isAddOpen, setAddOpen] = useState(false);
  const [selected, setSelected] = useState(false);
  const [searchValues, setSearchValues] = useState([]);
  const [detailKeys, setDetailKeys] = useState([]);
  const [currentDetailData, setCurrentDetailData] = useState({});

  const [selectedLabFindingsId, setSelectedLabFindingsId] = useState([]);
  const { wholeData, handleWholeData } = useContext(PrescriprionContext);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [sinceOption, setSinceOption] = useState([
    { label: "1d", value: "1d" },
    { label: "2d", value: "2d" },
    { label: "3d", value: "3d" },
    { label: "4d", value: "4d" },
    { label: "5d", value: "5d" },
    { label: "6d", value: "6d" },
    { label: "week", value: "week" },
    { label: "10d", value: "10d" },
  ]);

  const [, forceUpdate] = useState({});

  const [departmentList, setDepartmentList] = useState([]);

  /*useEffect(() => {
    // Fetch department list
    /*getDepartmentList(wholeData.doctorCode, (res) => {
      setDepartmentList(res);
    });
  }, [wholeData.doctorCode]);*/

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const [submissionData, setSubmissionData] = useState([]);
  const [submissionExamination, setSubmissionExamination] = useState({});
  const dispatch = useDispatch();

  useEffect(() => {
    setSearchValues(createSearchOptionsWithData(initialData));
  }, [initialData]);

  const [textareaHeight, setTextareaHeight] = useState("auto");

  useEffect(() => {
    const textarea = document.getElementById("noteTextarea");
    if (textarea) {
      setTextareaHeight(`${textarea.scrollHeight}px`);
    }
  }, [noteValue]);

  const isMultiSelect = useCallback(
    (item) => {
      const multiSelectItems = ["severity", "since", "more", "grade"];
      return mode === "multi" && multiSelectItems.includes(item);
    },
    [mode]
  );

  const createSearchOptionsWithData = (data) => {
    if (data && data.length > 0) {
      let result = [];
      data.map((e) => result.push({ label: e?.name, value: e?.name }));
      return result;
    } else {
      return [];
    }
  };

  const [selectedOption, setSelectedOption] = useState("");

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    console.info("selectedOption", event);
    //handleSubChange({ key: "Readings", selectedOption })
  };

  const handleSubChange = useCallback(
    ({ key, value }) => {
      setSubmissionExamination((prevState) => {
        const detailItem = currentDetailData.find((d) => d.name === key);

        if (detailItem?.selection === "Multi Select") {
          const prevValues = prevState[key] || [];
          const isValueSelected = prevValues.includes(value);

          if (detailItem.restriction) {
            const maxAllowed = parseInt(detailItem.restriction.split(" ")[1]);

            if (isValueSelected) {
              return {
                ...prevState,
                [key]: prevValues.filter((val) => val !== value),
              };
            } else {
              if (prevValues.length < maxAllowed) {
                return {
                  ...prevState,
                  [key]: [...prevValues, value],
                };
              } else {
                return {
                  ...prevState,
                  [key]: [...prevValues.slice(1), value],
                };
              }
            }
          }

          return {
            ...prevState,
            [key]: isValueSelected
              ? prevValues.filter((val) => val !== value)
              : [...prevValues, value],
          };
        } else {
          if (key === "Note") {
            return {
              ...prevState,
              [key]: value.trim() === "" ? [] : [value],
            };
          }
          return {
            ...prevState,
            [key]: [value],
          };
        }
      });

      setSelectedOptions((prevState) => ({
        ...prevState,
        [key]: value,
      }));

      forceUpdate({});
    },
    [currentDetailData]
  );

  const isSelected = (params) => {
    let { name } = params;
    let data = submissionData;
    if (data && data.length > 0) {
      let res = data.filter((e) => e.name === name);
      //  console.log("res",res)
      return res && res.length > 0;
    }
  };

  const handleSearchBox = (value) => {
    let _item = initialData.filter((e) => e.name === value)[0];
    console.debug("_item", _item, isSelected(_item), selectedLabFindingsId);
    if (!isSelected(_item)) {
      console.debug("if _item", _item, isSelected(_item));
      handleSearch(_item);
      handleSelectData(_item);
      setSelectedLabFindingsId(_item?.name);
    } else {
      handleSearch(_item);
      handleSelectData(_item);
      setSelectedLabFindingsId(_item?.name);
    }
    setSelected(() => _item);
    setOpne(true);
    setSearchValues(createSearchOptionsWithData(initialData));
  };

  const isInSearch = (e, data) => {
    console.debug("isInSearch", e, data);
    if (e?.trim()?.length) {
      for (let i = 0; i < e.length; i++) {
        if (e[i]?.toLowerCase() !== data?.name[i]?.toLowerCase()) {
          return false;
        }
      }
    }
    return true;
  };

  const handleOnSearch = (e) => {
    console.debug("e", e);
    if (initialData && initialData.length > 0 && e) {
      let filterData = initialData.filter((option) => isInSearch(e, option));
      console.debug("filterData", filterData);

      setSearchValues(createSearchOptionsWithData(filterData));
    } else if (!e?.trim()?.length)
      setSearchValues(createSearchOptionsWithData(initialData));
  };

  const handleItemClick = (name) => {
    setSelectedLabFindingsId(name.name);
    if (isSelected(name)) {
      if (isOpen) {
        setOpne(false);
      } else {
        setSelected(() => name);
        setOpne(true);
      }
    } else {
      dispatch(
        ManageDataInPrescription({
          context: "Toggle",
          item: "examination",
          payload: name,
          existing: submissionData?.examinations,
        })
      );
      setSelected(() => name);
      setOpne(true);
    }
  };
  const handleItemClickSelected = (name) => {
    console.log("handleItemClickSelected", name);
    setSelectedLabFindingsId(name.name);
    if (isSelected(name) && selected === name) {
      if (isOpen) {
        setOpne(false);
      } else {
        setSelected(() => name);
        setOpne(true);
      }
    } else {
      setSelected(() => name);
      setOpne(true);
    }
  };

  let handleAddIconClick = (e, name) => {
    e.stopPropagation();

    setSelectedLabFindingsId(name.name);
    if (isSelected(name)) {
      //console.log("handleAddIconClick",submissionData)
      handleUnSelectData(name);
      setOpne(false);
    } else {
      handleSelectData(name);
      setOpne(true);
    }
    toggle(name);
    //setOpne(true);
    setSelected(() => name);
  };

  const detailData = [
    {
      name: "Severity",
      selection: "Single Select",
      options: ["Mild", "Moderate", "Severe"],
      required: "true",
      restriction: "Max 1",
    },
    {
      name: "Since",
      selection: "Single Select",
      options: ["1D", "2D", "3D", "4D", "Week"],
      required: "true",
      restriction: "Max 1",
    },
    {
      name: "Note",
      selection: "Text Box",
      restriction: "Alphanumeric",
      required: "false",
    },
  ];

  const handleDetailedDatawee = () => {
    if (selectedLabFindingsId) {
      let current = detailedData?.find(
        (item) => item.labTestName === selectedLabFindingsId
      )?.labTestDetail;

      if (current) {
        setDetailKeys(current.map((item) => item.name));
        setCurrentDetailData(current);
      } else {
        setDetailKeys([]);
        setCurrentDetailData([]);
      }
    }
  };

  const detailDatakey =
    '{"since": ["1d","2d","3d","4d","week"],"severity": ["Mild","Moderate","Severe"]}';

  const keyValue = detailData.map((item) => item.name);

  const handleAddData = async (name) => {
    const departmentId = departmentList[0]?.departmentId;

    await saveLabFindings(
      name.name,
      detailData,
      callBackFunction
    );
    setSelectedLabFindingsId(name.name);
    setOpne(true);
    handleSelectData(name);
    setDetailKeys(keyValue);
    setCurrentDetailData(detailData);
    dispatch(
      ManageDataInPrescription({
        context: "Add",
        item: "examination",
        payload: name,
        existing: initialData,
      })
    );
    dispatch(
      ManageDataInPrescription({
        context: "Toggle",
        item: "examination",
        payload: name,
        existing: submissionData?.examinations,
      })
    );
    setSelected(() => name);
  };

  const getSubValue = (key) => {
    return submissionExamination[key];
  };

  const isSubSelected = (key, value) => {
    if (Object.keys(submissionExamination).includes(key)) {
      return submissionExamination[key].includes(value);
    } else {
      return false;
    }
  };

  const isAnArray = (data) => {
    return Array.isArray(data);
  };

  let readingitems = [
    "Respiratory rate",
    "BP",
    "Pulses",
    "Blood pressure",
    "Pulse",
    "Cyanosis",
  ];
  const handleDetailedData = () => {
    if (selectedLabFindingsId) {
      let selectedItem = detailedData?.find(
        (item) => item.labTestName === selectedLabFindingsId
      );

      let current = selectedItem?.labTestDetail;

      if (Array.isArray(current)) {
        setDetailKeys(current.map((item) => item?.name));
        setCurrentDetailData(current);
      } else {
        console.warn("labTestDetail is not an array:", current);
        setDetailKeys([]);
        setCurrentDetailData([]);
      }
    } else {
      setDetailKeys([]);
      setCurrentDetailData([]);
    }
  };

  const handleAutoCompleteOptions = (e) => {
    setSinceOption(sinceOption?.filter((item) => item?.name?.indexOf(e) > -1));
  };

  const handleExaminationData = () => {
    const dataIndex = submissionData.findIndex(
      (item) => item.name === selectedLabFindingsId
    );
    setSubmissionExamination(submissionData[dataIndex]?.detailData ?? {});
  };

  useEffect(() => {
    if (Object.keys(detailedData).length) {
      handleDetailedData();
      handleExaminationData();
    }
  }, [selectedLabFindingsId]);

  const handleDetailDataSelection = () => {
    let temp = [...submissionData];
    const currentIndex = temp.findIndex(
      (item) => item.name === selectedLabFindingsId
    );
    temp[currentIndex] = {
      ...temp[currentIndex],
      detailData: submissionExamination,
    };
    setSubmissionData(temp);
  };

  useEffect(() => {
    if (Object.keys(submissionExamination).length) {
      handleDetailDataSelection();
    }
  }, [submissionExamination]);

  const pushToWholeData = (key, data) => {
    handleWholeData(key, data);
  };

  useEffect(() => {
    if (submissionData?.length > 0) {
      pushToWholeData("examinations", submissionData);
    }
  }, [submissionData]);

  const handleSubmissionData = (data) => {
    setSubmissionData(data);
  };

  useEffect(() => {
    if (wholeData?.examinations !== submissionData) {
      handleSubmissionData(wholeData?.examinations);
      if (wholeData?.examinations?.length > 0) {
        setSelectedLabFindingsId(wholeData?.examinations[0]?.name);

        setOpne(true);
      } else {
        setOpne(false);
      }
    }
  }, [wholeData?.examinations]);

  const handleSelectData = (name) => {
    setSubmissionData([...submissionData, name]);
  };

  const handleUnSelectData = (name) => {
    const updatedSubmissionData = submissionData.filter(item => item.name !== name.name);
    setSubmissionData(updatedSubmissionData);
    
    // Update wholeData
    handleWholeData("examinations", updatedSubmissionData);

    // Dispatch action to update global state if needed
    dispatch(
      ManageDataInPrescription({
        context: "Remove",
        item: "examination",
        payload: name,
        existing: updatedSubmissionData,
      })
    );
  };

  const handleKeyPress = (event) => {
    const keyCode = event.which || event.keyCode;
    const allowedKeys = [
      32, // Space character
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57, // Numbers (0-9)
      // Alphabets (A-Z, a-z)
      ...Array.from({ length: 26 }, (_, i) => i + 65),
      ...Array.from({ length: 26 }, (_, i) => i + 97),
    ];

    if (!allowedKeys.includes(keyCode)) {
      event.preventDefault();
    }
  };

  document.addEventListener("paste", function (event) {
    event.preventDefault(); // Prevent the default paste behavior
    // You can optionally display a message or perform any other action here
  });

  console.debug("detailKeys", detailKeys);

  const handleKeyDown = (e) => {
    if (e.key === "%") {
      e.preventDefault();
    }
  };

  const splitTextIntoChunks = (text, chunkSize) => {
    const words = text.split(" ");
    const chunks = [];
    let currentChunk = "";

    for (let i = 0; i < words.length; i++) {
      if ((currentChunk + words[i]).length <= chunkSize) {
        currentChunk += words[i] + " ";
      } else {
        chunks.push(currentChunk.trim());
        currentChunk = words[i] + " ";
      }
    }

    if (currentChunk.trim().length > 0) {
      chunks.push(currentChunk.trim());
    }

    return chunks;
  };

  const renderSplitText = (text) => {
    return splitTextIntoChunks(text, 50).map((chunk, index) => (
      <React.Fragment key={index}>
        {index !== 0 && <br />}
        {chunk}
      </React.Fragment>
    ));
  };

  return (
    <>
      <div className={styles.data_box_wrap}>
        <div className={styles.medication_box_container}>
          <div className={styles.header}>
            <div className={styles.searchBox}>
              <Searchbox
                value={selected?.name || ""}
                options={searchValues}
                onSelect={handleSearchBox}
                onSearch={handleOnSearch}
                placeholder="Search"
              />
            </div>

            <button
              className={styles.add_new_button}
              onClick={() => {
                setAddOpen(true);
              }}
            >
              <span>Add new</span>
              <BlackAdd />
            </button>
          </div>

          <div className={styles.body}>
            <div className={styles.caption}>
              <ClockSmall />
              {name}
            </div>

            <div className={styles.data_list_wrap}>
              <div className={styles.data_list}>
                {initialData &&
                  initialData.length > 0 &&
                  initialData.map((each, key) => {
                    if (isSelected(each)) {
                      return (
                        <div
                          onClick={() => {
                            handleItemClickSelected(each);
                          }}
                          className={`${styles.data_list_item} ${
                            isSelected(each) && styles.data_list_item_selected
                          }`}
                          key={key}
                        >
                        <div>{renderSplitText(each?.name)}</div>
                          <div
                            onClick={(e) => {
                              handleAddIconClick(e, each);
                            }}
                            className={`${styles.addIcon} ${
                              !isSelected(each)
                                ? styles.addIconSelected
                                : styles.addIconNotSelected
                            }`}
                          >
                            <BlueAdd
                              isSelected={isSelected(each)}
                              scale={0.7}
                            />
                          </div>
                        </div>
                      );
                    }
                  })}
              </div>

              <div className={styles.data_list}>
                {initialData &&
                  initialData.length > 0 &&
                  initialData.slice(0, 10).map((each, key) => {
                    if (!isSelected(each)) {
                      return (
                        <div
                          onClick={(e) => {
                            handleAddIconClick(e, each);
                          }}
                          className={`${styles.data_list_item} ${
                            isSelected(each) && styles.data_list_item_selected
                          }`}
                          key={key}
                        >
                             <div>{renderSplitText(each?.name)}</div>
                          <div
                            onClick={(e) => {
                              handleAddIconClick(e, each);
                            }}
                            className={`${styles.addIcon} ${
                              !isSelected(each)
                                ? styles.addIconSelected
                                : styles.addIconNotSelected
                            }`}
                          >
                            <BlueAdd
                              isSelected={isSelected(each)}
                              scale={0.7}
                            />
                          </div>
                        </div>
                      );
                    }
                  })}
              </div>
            </div>
          </div>
        </div>

        <div
          className={`${styles.options_container} ${
            isOpen
              ? styles.options_container_open
              : styles.options_container_close
          }`}
        >
          <div className={styles.option_item}>
            <div className={styles.item_list}>
              <div className={`${styles.item} ${styles.item_title}`}>
                {selectedLabFindingsId}
              </div>
            </div>

            {/* {detailKeys.map((item, index) => {
              console.debug("selectedLabFindingsId", selectedLabFindingsId);
              console.debug("ietem", item);
              return (
                <div className={styles.option_item}>
                  <div className={styles.caption}>
                    {selectedLabFindingsId === "Cyanosis"
                      ? ""
                      : capitalizeFirstLetter(item)}
                  </div>

                  {item === "since" && (
                    <div className={styles.form_item}>
                      <input
                        key={selected}
                        value={
                          getSubValue("since") != undefined
                            ? getSubValue("since")
                            : ""
                        }
                        onChange={(e) => {
                          handleSubChange({
                            key: "since",
                            value: e.target.value,
                          });
                        }}
                        className={styles.form_item_input}
                        type="text"
                        placeholder="Type here"
                      />
                    </div>
                  )}
                  {item === "SPO2" && selectedLabFindingsId === "Chest" ? (
                    <div className={styles.form_item}>
                      <Textarea
                        key={selected}
                        value={
                          getSubValue("Readings") != undefined
                            ? getSubValue("Readings")
                            : ""
                        }
                        onKeyPress={handleKeyPress}
                        onChange={(e) => {
                          handleSubChange({
                            key: "Readings",
                            value: e.target.value,
                          });
                        }}
                        className={styles.form_item_input}
                        type="text"
                        placeholder="Type here readings"
                        maxLength={200}
                      />
                    </div>
                  ) : (
                    item === "Readings" &&
                    (selectedLabFindingsId === "Cyanosis" ? (
                      <div>
                        <RadioButton
                          label="Yes"
                          value="Yes"
                          className={styles.form_item_input}
                          checked={
                            getSubValue("Readings") != undefined
                              ? getSubValue("Readings").join(" ") === "Yes"
                              : ""
                          }
                          onChange={(e) => {
                            handleOptionChange(e);
                            handleSubChange({ key: "Readings", value: "Yes" });
                          }}
                        />
                        <RadioButton
                          label="No"
                          value="No"
                          className={styles.form_item_input}
                          checked={
                            getSubValue("Readings") != undefined
                              ? getSubValue("Readings").join(" ") === "No"
                              : ""
                          }
                          onChange={(e) => {
                            handleOptionChange(e);
                            handleSubChange({ key: "Readings", value: "No" });
                          }}
                        />
                      </div>
                    ) : (
                      <div className={styles.form_item}>
                        <Textarea
                          key={selected}
                          value={
                            getSubValue("Readings") != undefined
                              ? getSubValue("Readings")
                              : ""
                          }
                          onKeyPress={handleKeyPress}
                          onChange={(e) => {
                            handleSubChange({
                              key: "Readings",
                              value: e.target.value,
                            });
                          }}
                          className={styles.form_item_input}
                          type="text"
                          placeholder="Type here readings"
                          maxLength={200}
                        />
                      </div>
                    ))
                  )}

                  {selectedLabFindingsId === "CNS" && item === "status" ? (
                    <div className={styles.item_list}>
                      {isAnArray(currentDetailData[item]) &&
                        currentDetailData[item]?.map((each, key) => {
                          return (
                            <div
                              key={key}
                              onClick={() => {
                                handleSubChanges({ key: item, value: each });
                              }}
                              className={`${styles.item} ${
                                item === "since" ? styles.since : ""
                              } ${
                                isSubSelected(item, each) &&
                                styles.sub_item_selected
                              }`}
                            >
                              {each}
                            </div>
                          );
                        })}
                    </div>
                  ) : selectedLabFindingsId === "CVS" && item === "status" ? (
                    <div className={styles.item_list}>
                      {isAnArray(currentDetailData[item]) &&
                        currentDetailData[item]?.map((each, key) => {
                          return (
                            <div
                              key={key}
                              onClick={() => {
                                handleSubChanges({ key: item, value: each });
                              }}
                              className={`${styles.item} ${
                                item === "since" ? styles.since : ""
                              } ${
                                isSubSelected(item, each) &&
                                styles.sub_item_selected
                              }`}
                            >
                              {each}
                            </div>
                          );
                        })}
                    </div>
                  ) : (
                    <div className={styles.item_list}>
                      {isAnArray(currentDetailData[item]) &&
                        currentDetailData[item]?.map((each, key) => {
                          return (
                            <div
                              key={key}
                              onClick={() => {
                                handleSubChange({ key: item, value: each });
                              }}
                              className={`${styles.item} ${
                                item === "since" ? styles.since : ""
                              } ${
                                isSubSelected(item, each) &&
                                styles.sub_item_selected
                              }`}
                            >
                              {each}
                            </div>
                          );
                        })}
                    </div>
                  )}
                </div>
              );
            })} */}

            {detailKeys.map((item, index) => {
              const detailItem = currentDetailData.find(
                (d) => d?.name === item
              );

              if (!detailItem) {
                console.warn(`No detail item found for ${item}`);
                return null; // or return some placeholder component
              }
              console.debug("value", getSubValue(detailItem.name));
              return (
                <div className={styles.option_item} key={index}>
                  <div className={styles.caption}>
                    {capitalizeFirstLetter(detailItem.name)}
                  </div>
                  {detailItem.selection === "Single Select" && (
                    <div className={styles.item_list}>
                      {detailItem.options?.map((each, key) => (
                        <div
                          key={key}
                          onClick={() =>
                            handleSubChange({
                              key: detailItem.name,
                              value: each,
                            })
                          }
                          className={`${styles.item} ${
                            isSubSelected(detailItem.name, each)
                              ? styles.sub_item_selected
                              : ""
                          }`}
                        >
                          {each}
                        </div>
                      ))}
                    </div>
                  )}
                  {detailItem.selection === "Multi Select" && (
                    <div className={styles.item_list}>
                      {detailItem.options?.map((each, key) => (
                        <div
                          key={key}
                          onClick={() =>
                            handleSubChange({
                              key: detailItem.name,
                              value: each,
                            })
                          }
                          className={`${styles.item} ${
                            isSubSelected(detailItem.name, each)
                              ? styles.sub_item_selected
                              : ""
                          }`}
                        >
                          {each}
                        </div>
                      ))}
                    </div>
                  )}
                  {detailItem.selection === "Radio Button" && (
                    <Radio.Group
                      value={getSubValue(detailItem.name)?.[0]}
                      onChange={(e) =>
                        handleSubChange({
                          key: detailItem.name,
                          value: e.target.value,
                        })
                      }
                    >
                      {detailItem.options?.map((each, key) => (
                        <Radio key={key} value={each}>
                          {each}
                        </Radio>
                      ))}
                    </Radio.Group>
                  )}
                  {detailItem.selection === "Drop Down" && (
                    <Select
                      options={detailItem.options.map((opt) => ({
                        value: opt,
                        label: opt,
                      }))}
                      value={getSubValue(detailItem.name)?.[0]}
                      onChange={(value) =>
                        handleSubChange({ key: detailItem.name, value })
                      }
                      className={styles.form_item_input}
                      style={{ width: "100%" }}
                    />
                  )}

                  {detailItem.selection === "Text Box" && (
                    <Textarea
                      value={getSubValue(detailItem.name)?.[0] || ""}
                      onChange={(e) =>
                        handleSubChange({
                          key: detailItem.name,
                          value: e.target.value,
                        })
                      }
                      className={styles.form_item_input}
                      placeholder="Type here"
                      maxLength={200}
                      onPaste={(e) => {
                        e.preventDefault(); // Prevent default paste behavior
                        const pastedData =
                          e.clipboardData.getData("text/plain");
                        const start = e.target.selectionStart;
                        const end = e.target.selectionEnd;
                        const currentValue = e.target.value;

                        // Calculate the available space
                        const availableSpace =
                          200 - (currentValue.length - (end - start));

                        // Truncate the pasted data if necessary
                        const truncatedPastedData = pastedData.substring(
                          0,
                          availableSpace
                        );

                        const newValue =
                          currentValue.substring(0, start) +
                          truncatedPastedData +
                          currentValue.substring(end);

                        // Use the existing handleSubChange function to update the state
                        handleSubChange({
                          key: detailItem.name,
                          value: newValue.substring(0, 200), // Ensure it doesn't exceed 200 characters
                        });

                        // Set cursor position after the pasted text
                        setTimeout(() => {
                          e.target.setSelectionRange(
                            start + truncatedPastedData.length,
                            start + truncatedPastedData.length
                          );
                        }, 0);
                      }}
                    />
                  )}
                </div>
              );
            })}

            {(selectedLabFindingsId === "Heart Rate" ||
              selectedLabFindingsId === "Respiratory Rate" ||
              selectedLabFindingsId === "BP") && (
              <div className={styles.option_item}>
                <div className={styles.caption}>Note</div>
                <div className={styles.form_item}>
                  <Textarea
                    value={getSubValue("note") ?? ""}
                    onChange={(e) => {
                      handleSubChange({ key: "note", value: e.target.value });
                    }}
                    className={styles.textarea}
                    style={{ height: textareaHeight }}
                    placeholder="Type here"
                    maxLength={200}
                    onKeyDown={handleKeyDown}
                    onPaste={(e) => {
                      e.preventDefault(); // Prevent default paste behavior
                      const pastedData = e.clipboardData.getData("text/plain");
                      const start = e.target.selectionStart;
                      const end = e.target.selectionEnd;
                      const currentValue = e.target.value;

                      // Calculate the available space
                      const availableSpace =
                        200 - (currentValue.length - (end - start));

                      // Truncate the pasted data if necessary
                      const truncatedPastedData = pastedData.substring(
                        0,
                        availableSpace
                      );

                      const newValue =
                        currentValue.substring(0, start) +
                        truncatedPastedData +
                        currentValue.substring(end);

                      // Use the existing handleSubChange function to update the state
                      handleSubChange({
                        key: "note",
                        value: newValue.substring(0, 200),
                      });

                      // Set cursor position after the pasted text
                      setTimeout(() => {
                        e.target.setSelectionRange(
                          start + truncatedPastedData.length,
                          start + truncatedPastedData.length
                        );
                      }, 0);
                    }}
                  />
                </div>
              </div>
            )}

          </div>
        </div>
      </div>

      <AddDataModal
        onSubmit={(e) => {
          handleAddData(e);
        }}
        title={addTitle ? addTitle : "Add new"}
        showModal={isAddOpen}
        hidemodal={() => {
          setAddOpen(false);
        }}
      />
    </>
  );
}

export default ExaminationBox;
